// 校验身份证号码
var checkIdentitytionId = (rule, value, callback) => {
	if (!value) {
		return callback(new Error("身份证号不能为空"));
	}
	if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
		callback(new Error("你输入的身份证长度或格式错误"));
	}
	//身份证城市
	var aCity = {
		11: "北京",
		12: "天津",
		13: "河北",
		14: "山西",
		15: "内蒙古",
		21: "辽宁",
		22: "吉林",
		23: "黑龙江",
		31: "上海",
		32: "江苏",
		33: "浙江",
		34: "安徽",
		35: "福建",
		36: "江西",
		37: "山东",
		41: "河南",
		42: "湖北",
		43: "湖南",
		44: "广东",
		45: "广西",
		46: "海南",
		50: "重庆",
		51: "四川",
		52: "贵州",
		53: "云南",
		54: "西藏",
		61: "陕西",
		62: "甘肃",
		63: "青海",
		64: "宁夏",
		65: "新疆",
		71: "台湾",
		81: "香港",
		82: "澳门",
		91: "国外"
	};
	if (!aCity[parseInt(value.substr(0, 2))]) {
		callback(new Error("你的身份证地区非法"));
	}
	// 出生日期验证
	var sBirthday = (
			value.substr(6, 4) +
			"-" +
			Number(value.substr(10, 2)) +
			"-" +
			Number(value.substr(12, 2))
		).replace(/-/g, "/"),
		d = new Date(sBirthday);
	if (
		sBirthday !=
		d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
	) {
		callback(new Error("身份证上的出生日期非法"));
	}

	// 身份证号码校验
	var sum = 0,
		weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
		codes = "10X98765432";
	for (var i = 0; i < value.length - 1; i++) {
		sum += value[i] * weights[i];
	}
	var last = codes[sum % 11]; //计算出来的最后一位身份证号码
	if (value[value.length - 1] != last) {
		callback(new Error("你输入的身份证号非法"));
	}
	callback();
};

// 设置手机号的验证规则
const phoneRules = (rule, value, callback) => {
	// value.toString()
	// if(value.length>11){
	// 	this.$message.warning("请输入11位手机号")
	// 	value.slice(0,11)
	// 	return
	// }
	if (!value) {
		callback(new Error('请输入联系方式'))
	} else {

		const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
		if (reg.test(value)) {
			callback()
		} else {
			return callback(new Error('请输入正确的电话'))
		}
	}
}


/* 合法真实姓名 */
const validateRealName = (rule, value, callback) => {
	const realnameReg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
	console.log(1111)
	if (!value) {
		return callback(new Error('姓名不能为空!!'))
	}
	if (!realnameReg.test(value)) {
		return callback(new Error('姓名格式错误,请输入英文或汉字!'))
	} else {
		callback()
	}
}

export {
	checkIdentitytionId,
	phoneRules,
	validateRealName,
};
